import React, { memo, useEffect, useMemo, useState } from 'react';
import TradeFunction from './TradeFunction';
import { makeInstrumentByIdSelector } from '../../../redux/selector';
import { useAppDispatch, useAppSelector } from '../../../redux/app';
import BuyStopFunction from '../buy-sell-stop';
import BuyLimitFunction from '../buy-sell-limit';
import BuyStopLimitFunction from '../buy-sell-stop-limit';
import { setPayload } from '../../../redux/reducer/payload';
import { setTradeDialog } from '../../../redux/reducer/dialog';

const TradeDialog = memo(({ type }) => {
  const active = useAppSelector((state) => state.symbol?.active);
  const payload = useAppSelector((state) => state.payload?.payload);
  const getSymbol = useMemo(makeInstrumentByIdSelector, []);
  const symbol = useAppSelector((state) => getSymbol(state, active));
  const [marketOption, setMarketOption] = useState(1);
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  // const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   if (open) {
  //     setTimeout(() => {
  //       setLoading(open);
  //     }, 200);
  //   } else {
  //     setLoading(false);
  //   }
  // }, [open]);

  const toggle = () => {
    setOpen(!open);
  };

  const ExecMode = {
    0: 'Request Execution',
    1: 'Instant Execution',
    2: 'Market Execution',
    3: 'Exchange Execution'
  };

  const List = useMemo(() => {
    if (symbol) {
      return [
        ExecMode[symbol.exec_mode],
        'Buy Limit',
        'Sell Limit',
        'Buy Stop',
        'Sell Stop',
        'Buy Stop Limit',
        'Sell Stop Limit'
      ];
    }
    return [
      'Market Execution',
      'Buy Limit',
      'Sell Limit',
      'Buy Stop',
      'Sell Stop',
      'Buy Stop Limit',
      'Sell Stop Limit'
    ];
  }, [symbol]);

  const marketOptions = (type) => {
    switch (type) {
      case 1:
        return <TradeFunction />;
      case 2:
        return <BuyLimitFunction isBuyLimit />;
      case 3:
        return <BuyLimitFunction />;
      case 4:
        return <BuyStopFunction isBuyStop />;
      case 5:
        return <BuyStopFunction />;
      case 6:
        return <BuyStopLimitFunction isBuyStopLimit />;
      case 7:
        return <BuyStopLimitFunction />;
      default:
        return <div />;
    }
  };

  return (
    <div
      style={{
        transform: type === 'trade' ? 'translateX(0%)' : 'translateX(-125%)',
        position: 'fixed',
        left: '80px',
        top: '65px',
        backgroundColor: '#151515'
      }}>
      <div className='text-[#e5e5e5] text-md font-bold p-4 flex justify-between items-center border-r border-[#232323]'>Trading
        <div
          className="border-r border-r-[#232323] h-full flex cursor-pointer"
          onClick={() => {
            dispatch(setTradeDialog({ isOpen: false, type: '' }))
          }}>
          <svg
            className="m-auto history-btn-action"
            width="11"
            height="11"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.781396 16.0001C0.626858 16.0001 0.475783 15.9543 0.347281 15.8685C0.218778 15.7826 0.118621 15.6606 0.0594776 15.5178C0.000334661 15.3751 -0.0151369 15.218 0.0150198 15.0664C0.0451766 14.9148 0.119607 14.7756 0.228896 14.6664L14.6664 0.228853C14.8129 0.0823209 15.0117 0 15.2189 0C15.4261 0 15.6249 0.0823209 15.7714 0.228853C15.9179 0.375385 16.0002 0.574125 16.0002 0.781353C16.0002 0.988581 15.9179 1.18732 15.7714 1.33385L1.3339 15.7714C1.26141 15.844 1.17528 15.9016 1.08047 15.9408C0.985653 15.9801 0.884016 16.0002 0.781396 16.0001Z"
              fill="#9f9f9f"
            />
            <path
              d="M15.2189 16.0001C15.1162 16.0002 15.0146 15.9801 14.9198 15.9408C14.825 15.9016 14.7388 15.844 14.6664 15.7714L0.228853 1.33385C0.0823209 1.18732 0 0.988581 0 0.781353C0 0.574125 0.0823209 0.375385 0.228853 0.228853C0.375385 0.0823209 0.574125 0 0.781353 0C0.988581 0 1.18732 0.0823209 1.33385 0.228853L15.7714 14.6664C15.8806 14.7756 15.9551 14.9148 15.9852 15.0664C16.0154 15.218 15.9999 15.3751 15.9408 15.5178C15.8816 15.6606 15.7815 15.7826 15.653 15.8685C15.5245 15.9543 15.3734 16.0001 15.2189 16.0001Z"
              fill="#9f9f9f"
            />
          </svg>
        </div>
      </div>
      <div className="trade-dialog">
        <div className="trade-dialog-header">
          <div className="relative w-full flex flex-col">
            <div className="rounded-lg flex-1">
              <div
                className="flex px-3 justify-between items-center cursor-pointer h-[40px]"
                onClick={toggle}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = '#0FEF9E';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = open ? '#0FEF9E' : '#4B4B4B';
                }}
                style={{
                  borderColor: open ? '#0FEF9E' : '#4B4B4B',
                  borderStyle: 'solid',
                  borderWidth: '1px',
                  borderRadius: '8px'
                }}
              >
                <div className="text-[#9f9f9f] text-sm">{List[marketOption - 1]}</div>
                <div>
                  <svg
                    className={`transition-all ${open ? 'rotate-0' : 'rotate-180'}`}
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      {' '}
                      <path
                        d="M18.2929 15.2893C18.6834 14.8988 18.6834 14.2656 18.2929 13.8751L13.4007 8.98766C12.6195 8.20726 11.3537 8.20757 10.5729 8.98835L5.68257 13.8787C5.29205 14.2692 5.29205 14.9024 5.68257 15.2929C6.0731 15.6835 6.70626 15.6835 7.09679 15.2929L11.2824 11.1073C11.673 10.7168 12.3061 10.7168 12.6966 11.1073L16.8787 15.2893C17.2692 15.6798 17.9024 15.6798 18.2929 15.2893Z"
                        fill="#9f9f9f"></path>{' '}
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            {open && (
              <div
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={toggle}
                className="absolute top-[62px] z-50 left-1/2 -translate-x-1/2 bg-[#202020] border border-[#80808059] w-[373px] flex flex-col rounded-md">
                {List.map((e, i) => (
                  <div
                    onClick={() => {
                      setMarketOption(i + 1);
                      toggle();
                      dispatch(
                        setPayload({
                          ...payload,
                          price_order: 0,
                          price_trigger: 0,
                          price_sl: 0,
                          price_tp: 0
                        })
                      );
                    }}
                    key={e}
                    className="text-[#e5e5e5] text-sm px-4 h-[30px] flex items-center hover:bg-[#404040] transition-all cursor-pointer">
                    {e}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        {type === 'trade' && marketOptions(marketOption)}
      </div>
    </div>
  );
});

TradeDialog.displayName = 'TradeDialog';

export default TradeDialog;
